import React, { useState } from "react";
import "../styles/NavigatorСodehelppanel.css";
import { useGame } from "../GameContext";

const Helppanel: React.FC = () => {
  console.log("HelpPanel render");
  const { isHelpPanelOpen, setHelpPanelOpen } = useGame();
  const [showhelpPivots, setShowhelpPivots] = useState<string>("pivotTask");

  if (!isHelpPanelOpen) {
    return null;
  }

  return (
    <div className="navigatorСode-helpPanel" id="navigatorСode-helpPanel">
      <img
        src="/img/close.svg"
        id="navigatorСode-closeButton"
        alt="Закрыть"
        className="navigatorСode-closeButton"
        onClick={() => setHelpPanelOpen(false)}
      />
      <div className="navigatorСode-helpPivots">
        <div
          className="navigatorСode-selectPivots"
          id={showhelpPivots === "pivotTask" ? "navigatorСode-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotTask")}
        >
          Задача
        </div>
      </div>
      {showhelpPivots === "pivotTask" && (
        <div id="navigatorСode-commandsCards">
          <div className="navigatorСode-helpCard">
            <div className="navigatorСode-cardCaption">Суть игры</div>
            <div>
              <div>
                123123!!!!
              </div>
            </div>
          </div>
          <div className="navigatorСode-helpCard">
            <div className="navigatorСode-cardCaption">Правила игры</div>
            <div>
              <div>
                123123123!!!!
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Helppanel;
